// ============================================
// 📄 UTILITÁRIO GLOBAL DE EXPORTAÇÃO PDF — CLICK SORVETES
// Versão 4.0 Clean (mantém o visual real da tela)
// ============================================

import html2pdf from "html2pdf.js";

export async function exportarPDFGlobal(
  seletor,
  nomeArquivo = "relatorio-click",
  opcoes = {},
) {
  try {
    const elemento = document.querySelector(seletor);
    if (!elemento) throw new Error(`Elemento não encontrado: ${seletor}`);

    // 🔹 Esconde botões e interativos temporariamente
    const botoes = elemento.querySelectorAll(
      "button, .acoes-card, .btn-export",
    );
    botoes.forEach((b) => (b.style.display = "none"));

    // 🔹 Força cor de fundo branca e remove possíveis sombras no PDF
    const wrapper = document.createElement("div");
    wrapper.style.backgroundColor = "#ffffff";
    wrapper.style.width = "100%";
    wrapper.style.minHeight = "100vh";
    wrapper.style.display = "flex";
    wrapper.style.justifyContent = "center";
    wrapper.style.alignItems = "flex-start";
    wrapper.style.padding = "40px 0";
    wrapper.style.boxSizing = "border-box";

    // Clona o elemento atual (mantém o mesmo layout)
    const clone = elemento.cloneNode(true);
    clone.style.backgroundColor = "#ffffff";
    clone.style.boxShadow = "none";
    clone.style.color = "#111";
    clone.style.width = "90%";
    clone.style.borderRadius = "10px";
    clone.style.padding = "24px 28px";

    wrapper.appendChild(clone);

    // 🔹 Configuração do PDF
    const config = Object.assign(
      {
        margin: 0,
        filename: `${nomeArquivo}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2.5, // mais nítido
          useCORS: true,
          scrollY: 0,
          backgroundColor: "#ffffff",
          logging: false,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      },
      opcoes,
    );

    // 🔹 Renderização e download
    await html2pdf()
      .set(config)
      .from(wrapper)
      .toPdf()
      .get("pdf")
      .then((pdf) => pdf.save());

    // 🔹 Restaura os botões
    botoes.forEach((b) => (b.style.display = ""));
  } catch (erro) {
    //
  }
}
